import { render, staticRenderFns } from "./AS_ContactSideNav.vue?vue&type=template&id=2ad41ec4&scoped=true&"
import script from "./AS_ContactSideNav.vue?vue&type=script&lang=js&"
export * from "./AS_ContactSideNav.vue?vue&type=script&lang=js&"
import style0 from "./AS_ContactSideNav.vue?vue&type=style&index=0&id=2ad41ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad41ec4",
  null
  
)

export default component.exports